import { getProductVariationMap } from '../../hub/catalog';

export const catalogMutations = {
  queries: {
    getProductVariationMaps: (params: { productId: string; tenantId: string; branchId: string; componentId: string }) => ({
      queryKey: ['catalog', 'productVariationMap', params],
      queryFn: () => getProductVariationMap(params.productId, params.tenantId, params.branchId, params.componentId),
    }),
  },

  mutations: {
  },
};
